module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card"
  }, [_c('article', {
    staticClass: "modal-card-body has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('h3', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: ('challenges.quizz.your_challenge'),
      expression: "'challenges.quizz.your_challenge'"
    }],
    staticClass: "is-size-6"
  }), _vm._v(" "), _c('h4', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.challenge.name))]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: ('buttons.im_interested'),
      expression: "'buttons.im_interested'"
    }],
    staticClass: "button is-info",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "to": {
        name: 'challenge',
        params: {
          id: _vm.challenge.slug
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: ('buttons.im_not_interested'),
      expression: "'buttons.im_not_interested'"
    }],
    staticClass: "button is-text is-text-danger",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/challenge_ok.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0ef3e78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChallengePreview.vue
// module id = 369
// module chunks = 9